module.exports = __webpack_public_path__ + "img/turkey.341ceb5c.png";